import * as React from "react";

const Switch = (props: any) => (
  <svg width={64} height={64} viewBox="0 0 64 64" {...props}>
    <g transform="translate(12 20)" fill="none" fillRule="evenodd">
      <circle fill="#D2D5D8" cx={13} cy={12} r={10} />
      <rect
        stroke="#7B838C"
        strokeWidth={4}
        x={2}
        y={2}
        width={36}
        height={20}
        rx={10}
      />
      <rect
        stroke="#7B838C"
        strokeWidth={4}
        x={2}
        y={2}
        width={20}
        height={20}
        rx={10}
      />
    </g>
  </svg>
);

export default Switch;

